import CachedIcon from "@mui/icons-material/CachedRounded";
import {
  Box,
  FormControl,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
  Typography,
} from "@mui/material";
import { menuItemClasses } from "@mui/material/MenuItem";
import { selectClasses } from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { useContainer, useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import { useTemplateShippingProfiles } from "services/template";

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  [`&.${menuItemClasses.root}`]: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  [`&.${menuItemClasses.selected}`]: {
    // background: "red",
  },
}));

const Select = styled(MuiSelect)(({ theme }) => ({
  [`.${selectClasses.select}`]: {
    paddingRight: 40,
  },
  [`.${selectClasses.icon}`]: {
    right: 10,
    transition: theme.transitions.create(["transform"]),
  },
  [`.${selectClasses.iconOpen}`]: {
    transform: "rotate(180deg)",
  },
}));

export default function ShippingProfileSelector(): React.ReactElement {
  const { id: templateID } = useTemplate();
  const { data: shippingProfiles } = useTemplateShippingProfiles({
    id: templateID,
  });
  const [activeShippingProfileID, setActiveShippingProfileID] =
    useContainer.activeShippingProfileID();

  const activeShippingProfile = React.useMemo(() => {
    return shippingProfiles?.find(
      (item) => item.id === activeShippingProfileID
    );
  }, [activeShippingProfileID]);

  const handleChange = (e) => {
    setActiveShippingProfileID(parseInt(e.target.value));
  };

  return (
    <FormControl fullWidth>
      <Select
        id="shipping-profile-select"
        value={activeShippingProfileID}
        onChange={handleChange}
        IconComponent={CachedIcon}
        renderValue={() => (
          <Typography variant="body1">{activeShippingProfile?.name}</Typography>
        )}
      >
        {shippingProfiles?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <Box>
              <Typography variant="body1">{item.name}</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <Box component="b" sx={{ pr: 1 }}>
                  TYPE:
                </Box>
                {item.type === "DROP_SHIPPING" && "Drop Shipping"}
                {item.type === "BULK_SHIPPING" && "Bulk Shipping"}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
